// Live Masuren (de and en) uses portal id www.masuren-travel.com.
// Stage uses www.masuren-travel.de.
const MASUREN_PORTALS = new Set([
  'http://www.masuren-travel.com',
  'http://www.masuren-travel.de'
])

export function isMasurenPortal (portal: string | null | undefined): boolean {
  return MASUREN_PORTALS.has(portal ?? '')
}
